import { captureEvent } from '../../services/event-capture';
import { postMemberSettings } from '../../services/store/modules/app-controls';

export const getMeasurementSystemPresets = (system) => ({
  swellHeight: system === 'metric' ? 'metres' : 'feet',
  temperature: system === 'metric' ? 'celsius' : 'fahrenheit',
  tideHeight: system === 'metric' ? 'metres' : 'feet',
  windSpeed: system === 'metric' ? 'kmh' : 'knots',
  distance: system === 'metric' ? 'kilometre' : 'nauticalMile',
  speed: system === 'metric' ? 'kilometrePerHour' : 'knots',
});

export const decideMeasurementSystem = (dispatch, unitsConfig) => {
  // Find which measurement system the user is currently using, or if they have one (variable should be null if they don't)
  const usersUnitConfig = unitsConfig;

  const currentMeasurementSystem = usersUnitConfig.measurementSystem;

  const currentDistanceSetting = usersUnitConfig.distance;
  const currentSpeedSetting = usersUnitConfig.speed;

  const currentSwellHeightSetting = usersUnitConfig?.swellHeight;
  const currentTemperatureSetting = usersUnitConfig?.temperature;
  const currentTideHeightSetting = usersUnitConfig?.tideHeight;
  const currentWindSpeedSetting = usersUnitConfig?.windSpeed;

  if (
    currentMeasurementSystem === 'metric' ||
    currentMeasurementSystem === 'imperial'
  ) {
    // Get the preset settings for the system
    const presets = getMeasurementSystemPresets(currentMeasurementSystem);

    // Check if current settings align with a preset (Imperial or Metric)
    if (
      currentSwellHeightSetting === presets.swellHeight &&
      currentTemperatureSetting === presets.temperature &&
      currentTideHeightSetting === presets.tideHeight &&
      currentWindSpeedSetting === presets.windSpeed &&
      currentDistanceSetting === presets.distance &&
      currentSpeedSetting === presets.speed
    ) {
      // Return the same config to be used, i.e. it's valid
      return usersUnitConfig;
    }

    // The config is not valid, so have to update the config to be a 'custom' one
    usersUnitConfig.measurementSystem = 'custom';

    dispatch(
      postMemberSettings({
        unitsConfig: usersUnitConfig,
      }),
    );

    return usersUnitConfig;
  }

  return usersUnitConfig;
};

export const handleUpdateMeasurementSystem = (
  dispatch,
  unitsConfig,
  system,
) => {
  const presets = getMeasurementSystemPresets(system);
  const newUnitsConfig = {};

  newUnitsConfig.measurementSystem = system;
  newUnitsConfig.distance = presets.distance;
  newUnitsConfig.speed = presets.speed;
  newUnitsConfig.swellHeight = presets.swellHeight;
  newUnitsConfig.temperature = presets.temperature;
  newUnitsConfig.tideHeight = presets.tideHeight;
  newUnitsConfig.windSpeed = presets.windSpeed;
  newUnitsConfig.coordinate = unitsConfig.coordinate;

  dispatch(
    postMemberSettings({
      unitsConfig: newUnitsConfig,
    }),
  );
};

export const handleUpdateTripsConfig = (
  dispatch,
  tripsConfig,
  setting,
  value,
) => {
  const newTripsConfig = {
    ...tripsConfig,
  };

  newTripsConfig[setting] = value;

  dispatch(
    postMemberSettings({
      tripsConfig: newTripsConfig,
    }),
  );
};

export const handleUpdateWeatherConfig = (
  dispatch,
  weatherConfig,
  setting,
  value,
) => {
  const newWeatherConfig = {
    ...weatherConfig,
  };

  newWeatherConfig[setting] = value;

  captureEvent({
    type: 'Weather settings: update weather config',
    payload: { newWeatherConfig },
  });

  dispatch(
    postMemberSettings({
      weatherConfig: newWeatherConfig,
    }),
  );
};

export const handleUpdateUnitsConfig = (
  dispatch,
  unitsConfig,
  setting,
  newValue,
) => {
  const newUnitsConfig = { ...unitsConfig };

  newUnitsConfig[setting] = newValue;

  dispatch(
    postMemberSettings({
      unitsConfig: newUnitsConfig,
    }),
  );
};
